import type { TemplateConfig } from './constants.extra'

/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
 * Generated from /networks/berachain/config.json
 */
const TEMPLATE_CONFIG = {
  EIP155: false,
  SUPPORTED_VERSIONS: ['1.3.0', '1.4.1'],
  LOGO_DIMENSIONS: {
    HEADER: {
      H: '30px',
    },
    WELCOME: {
      W: '120px',
      H: '40px',
    },
  },
  WELCOME_PALETTE: '#F47226, #FDB72D',
} as TemplateConfig
export default TEMPLATE_CONFIG
